module.exports = __webpack_public_path__ + "img/security-safe.32839df.svg";